"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noUpdateCredit = exports.noMatchCredit = exports.insufficientHistoryCredit = exports.frozenCredit = exports.decreaseCredit = exports.noChangeCredit = exports.excellentCredit = exports.veryGoodCredit = exports.goodCredit = exports.fairCredit = exports.poorCredit = void 0;
exports.poorCredit = {
    credit_score: {
        current_score: 500,
        score_change_text: 'Down 4 points from last month',
        score_change_type: 'DECREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.fairCredit = {
    credit_score: {
        current_score: 650,
        score_change_text: 'Up 4 points from last month',
        score_change_type: 'INCREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.goodCredit = {
    credit_score: {
        current_score: 700,
        score_change_text: 'Up 4 points from last month',
        score_change_type: 'INCREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.veryGoodCredit = {
    credit_score: {
        current_score: 760,
        score_change_text: 'Up 4 points from last month',
        score_change_type: 'INCREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.excellentCredit = {
    credit_score: {
        current_score: 850,
        score_change_text: 'Up 4 points from last month',
        score_change_type: 'INCREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.noChangeCredit = {
    credit_score: {
        current_score: 760,
        score_change_text: 'No change from last month',
        score_change_type: 'NO_CHANGE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.decreaseCredit = {
    credit_score: {
        current_score: 760,
        score_change_text: 'Down 8 points from last month',
        score_change_type: 'DECREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updates monthly. Last updated May 24.',
        credit_status: 'OK',
    },
};
exports.frozenCredit = {
    credit_score: {
        current_score: null,
        score_change_text: null,
        score_change_type: null,
        credit_builder_tracking_time_text: null,
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: null,
        score_update_text: '',
        credit_status: 'FROZEN',
        credit_error_text: 'We can’t display your credit score because your credit is frozen',
    },
};
exports.insufficientHistoryCredit = {
    credit_score: {
        current_score: null,
        score_change_text: null,
        score_change_type: null,
        credit_builder_tracking_time_text: null,
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: null,
        score_update_text: '',
        credit_status: 'INSUFFICIENT_HISTORY',
        credit_error_text: 'We can’t display your credit score because you don’t have enough credit history',
    },
};
exports.noMatchCredit = {
    credit_score: {
        current_score: null,
        score_change_text: null,
        score_change_type: null,
        credit_builder_tracking_time_text: null,
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: null,
        score_update_text: '',
        credit_status: 'NO_MATCH',
        credit_error_text: 'We can’t find a credit profile that matches your information',
    },
};
exports.noUpdateCredit = {
    credit_score: {
        current_score: 786,
        score_change_text: '',
        score_change_type: 'INCREASE',
        credit_builder_tracking_time_text: '6 months',
        current_score_education: 'Vantage 3.0 TransUnion score',
        score_change_all_time_text: '+30 points',
        score_update_text: 'Updated monthly. Last updated March 24',
        credit_status: 'OK',
        credit_error_text: 'We couldn’t update your credit score last month',
    },
};
